export const EMPLOYEES_PATH = '/employees';
export const WORKERS_PATH = '/workers';
const LEGACY_EMPLOYEES_PATH = EMPLOYEES_PATH;

export const EMPLOYEE_ROUTE_PATHS = {
  // New routes
  TIMELINE: 'timeline',
  PERSONAL_LEGAL: 'personal-legal',
  CAREER_CAPABILITIES: 'career-capabilities',
  COMPENSATION: 'compensation',
  CONTRACTS: 'contracts',
  LEAVES: 'leaves',
  ASSESSMENTS: 'assessments',
  DOCUMENTS: 'documents',
  PERFORMANCE_REPORT: 'performance-report',
  COMPLIANCE: 'compliance',

  // Old
  LOGS: 'logs',
  QUALIFICATIONS: 'qualifications',
  BACKGROUND_CHECKS: 'backgroundChecks',
  PERFORMANCE_DATA: 'performance-data',
  COMPANY_ROLES: 'roles',
  ASSIGNMENTS: 'assignments',
  EDUCATION: 'education',
  OFFERS: 'offers',
  SKILLS: 'skills',
  FEEDBACKS: 'feedbacks',
  PERSONAL_LEGAL_EDIT: 'personal-legal/edit',
  POLICY_SIGN: 'policy/sign',
};

export const EMPLOYEE_MY_PAGE_PARAMETER = 'me';

export const EMPLOYEE_PORTAL_PATH = `${WORKERS_PATH}/me`;
export const LEGACY_EMPLOYEE_PORTAL_PATH = `${LEGACY_EMPLOYEES_PATH}/me`;
